
import md5 from 'md5'

export const getNewUrl = () => {
  const query = window.location.href.match(/#(.*)/)[0] || '';
  return `${window.location.origin}${window.location.pathname}${query}`;
};

const parseQuery = (str = location.search.substr(1)) => {
  const tempQuery = str.split('&').filter(item => item).map(item => {
    const tempItem = item.split('=');
    let value = decodeURIComponent(tempItem[1] || '""');
    if (value.charAt(0) !== '"') {
      value = `"${value}"`;
    }
    return {
      [decodeURIComponent(tempItem[0])]: JSON.parse(value)
    };
  });
  let result = Object.assign({}, ...tempQuery);
  return result;
};

export const getUrlQuery = (url = window.location.href) => {
  const link = url.replace(/\?.*$/, '');
  const queryStr = url.replace(link, '').replace(/^\??/, '').replace(/#.*$/, '');
  const query = parseQuery(queryStr);
  localStorage.setItem('UrlQuery', JSON.stringify(query));
  return query;
}

/**
 * 获取localStorage中query指定属性
 * @param {*} key
 */
export const getQueryItem = (key) => {
  const query = JSON.parse(localStorage.getItem('UrlQuery'));
  if (query) {
    return query[key] || '';
  }
  return '';
};

/**
 * 获取areaId
 */
export const getAreaId = () => {
  const query = JSON.parse(localStorage.getItem('UrlQuery'));
  if (query) {
    return query.areaID || query.areaId || query.areaid || query.areaiD;
  }
  return '';
}

/**
 * @desc 字符串规定长度超出...
 * @param {String} str 字符串
 * @param {Number} lng 保留长度
 */
export const BeyondReplace = (str = '',lng = 0) =>{
  if(!str||!lng) return ''
  if(str.length > Number(lng)){
    str = str.toString().slice(0,lng)+'...'
  }
  return str||''
}


export const sign = (body) => {
  let salt =  process.env.VUE_APP_HTTP_SALT;
  body = JSON.stringify(body);
  const sign = md5(salt + body)
  return sign
};

function getDate(time) {
	if (time instanceof Date) {
		return time
	}
	switch (typeof time) {
		case 'string': {
			// 2020-12-12T12:12:12.000Z、2020-12-12T12:12:12.000
			if (time.indexOf('T') > -1) {
				return new Date(time)
			}
			return new Date(time.replace(/-/g, '/'))
		}
		default:
			return new Date(time)
	}
}

export const dateFormat=(fmt, date)=> {
  let ret;
  if (!date && date !== 0) {
		return ''
	}
	date = getDate(date)
  const opt = {
      "Y+": date.getFullYear().toString(),        // 年
      "m+": (date.getMonth() + 1).toString(),     // 月
      "d+": date.getDate().toString(),            // 日
      "H+": date.getHours().toString(),           // 时
      "M+": date.getMinutes().toString(),         // 分
      "S+": date.getSeconds().toString()          // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
      ret = new RegExp("(" + k + ")").exec(fmt);
      if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
      };
  };
  return fmt;
};

///比较两个日期大小
export const dateCompare = (DateS,DateD,strMode) => 
{
  ///日期有效才能比较
  let result = true;
  if(!DateS || !DateD) return result;
  var date1=TransDate(Date.parse(DateS));
  var date2=TransDate(Date.parse(DateD));
  var _DateS=date1.getFullYear()+'-'+(date1.getMonth()+1)+'-'+date1.getDate();
  var _DateD=date2.getFullYear()+'-'+(date2.getMonth()+1)+'-'+date2.getDate();
  if (strMode == "0")
      result = Date.parse(_DateS) - Date.parse(_DateD) < 0 ? true : false;
  if (strMode == "1")
      result = Date.parse(_DateS) - Date.parse(_DateD) == 0 ? true : false;
  if (strMode == "2")
      result = Date.parse(_DateS) - Date.parse(_DateD) > 0 ? true : false;
  if (strMode == "3")
      result = Date.parse(_DateS) - Date.parse(_DateD) <= 0 ? true : false;
  if (strMode == "4")
      result = Date.parse(_DateS) - Date.parse(_DateD) >= 0 ? true : false;
  return result;
};

/*
*字符串转换时间
*js时间处理ios系统网页上时间显示Nan问题;ios只支持/
*/
export const TransDate = (time=0) => {
  var datetime = new Date();
  if (0 !== time && time !== '') {
      datetime = time;
  }
  if (typeof time === 'string' && time !== '') {
      //替换日期中的-为/
      var middle_time = time.replace(/-/g, '/');
      datetime = new Date(middle_time);
      if(datetime == 'Invalid Date'){
          datetime = new Date(time);
      }
  }
  if (typeof time === 'number' && 0 !== time) {
      datetime = new Date(time);
  }
  if (typeof time === 'object') {
      datetime = new Date(time);
  }
  return datetime;
}
